import {clamp01} from "./math";

export interface ITrapezoidalProfile {
    easeIn?: number;
    easeOut?: number;
}

const normalizeProfile = (profile: ITrapezoidalProfile): Required<ITrapezoidalProfile> => {
    const easeIn = clamp01(profile.easeIn ?? 0);
    const easeOut = clamp01(profile.easeOut ?? 0);
    const rampsLength = easeIn + easeOut;

    return rampsLength > 1 ? {easeIn: easeIn / rampsLength, easeOut: easeOut / rampsLength} : {easeIn, easeOut};
};

export const getTrapezoidalProgress = (progress: number, profile: ITrapezoidalProfile = {}): number => {
    const u = clamp01(progress);
    const {easeIn, easeOut} = normalizeProfile(profile);
    const speed = 1 / (1 - easeIn / 2 - easeOut / 2);
    const cruiseEnd = 1 - easeOut;

    if (u < easeIn) {
        const w = u / easeIn;

        return (speed * easeIn * w * w) / 2;
    }

    const cruise = speed * (easeIn / 2 + Math.min(u, cruiseEnd) - easeIn);

    if (u <= cruiseEnd) {
        return cruise;
    }

    const w = (u - cruiseEnd) / easeOut;

    return cruise + speed * easeOut * (w - (w * w) / 2);
};
import {clamp01} from "./math";

export interface ITrapezoidalProfile {
    easeIn?: number;
    easeOut?: number;
}

const normalizeProfile = (profile: ITrapezoidalProfile): Required<ITrapezoidalProfile> => {
    const easeIn = clamp01(profile.easeIn ?? 0);
    const easeOut = clamp01(profile.easeOut ?? 0);
    const rampsLength = easeIn + easeOut;

    return rampsLength > 1 ? {easeIn: easeIn / rampsLength, easeOut: easeOut / rampsLength} : {easeIn, easeOut};
};

export const getTrapezoidalProgress = (progress: number, profile: ITrapezoidalProfile = {}): number => {
    const u = clamp01(progress);
    const {easeIn, easeOut} = normalizeProfile(profile);
    const speed = 1 / (1 - easeIn / 2 - easeOut / 2);
    const cruiseEnd = 1 - easeOut;

    if (u < easeIn) {
        const w = u / easeIn;

        return (speed * easeIn * w * w) / 2;
    }

    const cruise = speed * (easeIn / 2 + Math.min(u, cruiseEnd) - easeIn);

    if (u <= cruiseEnd) {
        return cruise;
    }

    const w = (u - cruiseEnd) / easeOut;

    return cruise + speed * easeOut * (w - (w * w) / 2);
};
